interface BeckOnlineIsbnModule {
    produktURL: string;
    haupttitel: string;
}

const UTM_PARAMS =
    'utm_source=beck-shop.de&utm_medium=referral&utm_campaign=bs_clickout-passende-bo-module&em_src=cp&em_cmp=beck-shop.de_ref_clickout-passende-bo-module';

export function initBeckOnlineIsbnTab(): void {
    const tabButton = document.getElementById('tab-bo-module');
    const root = document.getElementById('bo-module-tab');
    if (!tabButton || !root) return;

    const spinner = document.getElementById('bo-module-tab-spinner');
    const empty = document.getElementById('bo-module-tab-empty');
    const heading = document.getElementById('bo-module-tab-heading');
    const list = document.getElementById('bo-module-tab-list');
    const error = document.getElementById('bo-module-tab-error');

    tabButton.addEventListener('click', async () => {
        if (root.dataset.loaded === 'true' || root.dataset.loading === 'true') return;
        const isbn = root.dataset.isbn;
        if (!isbn) return;

        root.dataset.loading = 'true';
        spinner?.classList.remove('hide');

        try {
            const response = await fetch(
                `/umbraco/api/ProduktdetailApi/GetBeckOnlineModulesByIsbn?isbn=${encodeURIComponent(isbn)}`
            );

            if (!response.ok) {
                spinner?.classList.add('hide');
                error?.classList.remove('hide');
                return;
            }

            const modules = (await response.json()) as BeckOnlineIsbnModule[];
            spinner?.classList.add('hide');

            // Defence-in-depth: only render http(s) URLs from the upstream factfinder.
            const safeModules = (modules ?? []).filter(m => /^https?:\/\//i.test(m.produktURL));

            if (safeModules.length === 0 || !list) {
                empty?.classList.remove('hide');
            } else {
                safeModules.forEach(m => {
                    const li = document.createElement('li');
                    const a = document.createElement('a');
                    const sep = m.produktURL.includes('?') ? '&' : '?';
                    a.href = `${m.produktURL}${sep}${UTM_PARAMS}`;
                    a.target = '_blank';
                    a.rel = 'noopener noreferrer';
                    a.textContent = m.haupttitel;
                    li.appendChild(a);
                    list.appendChild(li);
                });
                heading?.classList.remove('hide');
                list.classList.remove('hide');
            }
        } catch {
            spinner?.classList.add('hide');
            error?.classList.remove('hide');
        } finally {
            root.dataset.loading = 'false';
            root.dataset.loaded = 'true';
        }
    });
}
